module.exports = __webpack_public_path__ + "img/yellow-button-bg.bd03fa3b.svg";